module.exports = __webpack_public_path__ + "img/envelope-fill.8eb5bb6d.svg";